import { useMutation, useQueryClient } from '@tanstack/react-query';
import { storiesApi } from '@/lib/api-client';
import { notifications } from '@mantine/notifications';

export interface WrapUpData {
  storyId: string;
  sessionId: string;
  reflection: string;
}

export function useWrapUp() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ storyId, sessionId, reflection }: WrapUpData) =>
      storiesApi.saveStoryReflection(storyId, sessionId, reflection),
    onSuccess: () => {
      // Invalidate assignment queries since assignments may have been auto-completed
      queryClient.invalidateQueries({ queryKey: ['student', 'assignments'] });
      queryClient.invalidateQueries({ queryKey: ['student', 'assignments', 'count'] });

      notifications.show({
        title: 'Reflection Saved',
        message: 'Your reflection has been saved successfully!',
        color: 'teal',
      });
    },
    onError: (error: Error) => {
      notifications.show({
        title: 'Failed to Save',
        message: error.message || 'Could not save your reflection. Please try again.',
        color: 'red',
      });
    },
  });
}
